import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { routePath } from '@brightside-web/desktop/data-access/core-services';
import { Router } from '@angular/router';

@Component({
    selector: 'brightside-web-credit-complete-action',
    imports: [CommonModule, BrightsideUiModule],
    templateUrl: './credit-complete-action.component.html',
    styleUrl: './credit-complete-action.component.css'
})
export class CreditCompleteActionComponent {
  creditSetupActionCardConfig: ActionCardConfigInterface = {
    label: 'TAKE_ACTION',
    labelBold: true,
    labelSub: 'CREDIT_SETUP_ACTION_MINUTES',
    labelSubRemoveDash: true,
    labelIcon: 'actions',
    labelIconSize: 22,
    title: 'CREDIT_SETUP_ACTION_TITLE',
    body: 'CREDIT_SETUP_ACTION_DESC',
    cardStyle: 'small',
    shadow: true,
    marginBottom: 'small'
  };

  private _router: Router = inject(Router);

  routeToCredit() {
    this._router.navigate([routePath('credit_setup')]);
  }
}
